
function numberToWords(num) {
  if (num === 0) return "Zero";

  const belowTwenty = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const thousands = ["", "Thousand", "Million", "Billion"];

  function helper(n) {
    if (n === 0) return "";
    if (n < 20) return belowTwenty[n] + " ";
    if (n < 100) return tens[Math.floor(n / 10)] + " " + helper(n % 10);
    if (n < 1000)
      return belowTwenty[Math.floor(n / 100)] + " Hundred " + helper(n % 100);
    return "";
  }

  let i = 0,
    words = "";
  while (num > 0) {
    if (num % 1000 !== 0) {
      words = helper(num % 1000) + thousands[i] + " " + words;
    }
    num = Math.floor(num / 1000);
    i++;
  }
  return words.trim();
}

const currencyMap = {
  AED: { main: "Dirhams", sub: "Fils" },
  USD: { main: "Dollars", sub: "Cents" },
  GBP: { main: "Pounds", sub: "Pence" },
  EUR: { main: "Euros", sub: "Cents" },
  RMB: { main: "Yuan", sub: "Fen" }, // Chinese Yuan
  SAR: { main: "Riyals", sub: "Halalas" }, // Saudi Riyal
  SGD: { main: "Dollars", sub: "Cents" }, // Singapore Dollar
};

// Default fallback
const defaultCurrency = { main: "Units", sub: "Subunits" };

export function convertAmountToWords(amount, currency = "AED") {
  const integerPart = Math.floor(amount);
  const decimalPart = Math.round((amount - integerPart) * 100);

  const main = numberToWords(integerPart);
  const sub = decimalPart > 0 ? numberToWords(decimalPart) : "";

  const { main: currencyWord, sub: subCurrencyWord } =
    currencyMap[currency] || defaultCurrency;

  if (decimalPart > 0) {
    return `${currency}: ${main.toUpperCase()} ${currencyWord.toUpperCase()} AND ${sub.toUpperCase()} ${subCurrencyWord.toUpperCase()} ONLY`;
  } else {
    return `${currency}: ${main.toUpperCase()} ${currencyWord.toUpperCase()} ONLY`;
  }
}
